import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';
import { lightGrey2Color } from 'js/config/style';

export const breakpoint = 'md';

export default styled.div`
  display: grid;
  grid-template-columns: minmax(60px, 80px) 1fr;
  grid-template-areas: 'display details';
  border-bottom: 1px solid ${lightGrey2Color};
  box-shadow: 0 8px 9px -7px rgba(0, 0, 0, 0.2);
  position: relative;
  background: white;

  ${upTo(breakpoint)`
    grid-template-columns: 100%;
    grid-template-rows: 80px auto;
    grid-template-areas:
      'display'
      'details';
  `}
`;
